<template>
    <heads>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="applications" :action="{'text':'add application','url':route('heads.application.create')}" :searchlink="route('heads.application.search')"  :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Application Letter')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Application Letter')">
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Application Letter')" :href="route('heads.application.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </heads>
</template>

<script>
    import Heads from '@/Pages/Heads/Heads'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Heads,
            BreezeTable,
            ButtonLink
        },
        props:['applications'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'limit','label':'Limit'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
